import React from 'react';
import { View } from 'react-native';
import Text from '@/components/Typography/Text';
import { PRIORITY_USE_CASE_LINKS } from '@/constants/publicNavLinks';
import { EditorialLink } from './LandingValueStory';
import { Section, useLanding } from './LandingKit';
import { fluid } from './landingTokens';

const LANDING_USE_CASE_LINKS = PRIORITY_USE_CASE_LINKS.filter(
  item => item.href !== '/use-cases/free-thinkers',
);

export default function LandingPersonaLinks() {
  const { c, isCompact, width } = useLanding();
  return (
    <Section label="Ways to use Gab AI" style={{ borderTopWidth: 1, borderTopColor: c.rule }} contentStyle={{ paddingTop: fluid(width, 36, 52), paddingBottom: fluid(width, 36, 52) }}>
      <View style={{ flexDirection: isCompact ? 'column' : 'row', gap: isCompact ? 20 : 76 }}>
        <View style={{ flex: isCompact ? undefined : 0.9 }}>
          <Text tag="h2" weight="semibold" style={{ color: c.ink, fontSize: 26, lineHeight: 33, letterSpacing: -0.7 }}>Find a starting point.</Text>
          <Text tag="p" style={{ color: c.inkSoft, fontSize: 15, lineHeight: 24, marginTop: 12, maxWidth: 340 }}>See how small businesses, ministries, writers, developers, and others put Gab AI to work.</Text>
          <EditorialLink href="/use-cases" style={{ marginTop: 10 }}>All use cases</EditorialLink>
        </View>
        <View style={{ flex: isCompact ? undefined : 1.55, flexDirection: 'row', flexWrap: 'wrap', columnGap: 28 }}>
          {LANDING_USE_CASE_LINKS.map(item => (
            <EditorialLink key={item.href} href={item.href} style={{ width: isCompact ? '100%' : '46%', paddingVertical: 8 }}>{item.label}</EditorialLink>
          ))}
        </View>
      </View>
    </Section>
  );
}
